import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_OVERTIME_ENTRIES } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import getOvertimeEntryModel from '@/store/modules/models/overtimeEntry'

const overtimeEntries = {
  namespaced: true,
  state: buildInitialState({
    overtimeEntriesList: [],
    ...getOvertimeEntryModel()
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setOvertimeEntries: (state, overtimeEntries) => {
      state.overtimeEntriesList = overtimeEntries
    },
    setOvertimeEntry (state, overtimeEntry) {
      state.id = overtimeEntry.id
      state.assignmentId = overtimeEntry.assignmentId
      state.date = overtimeEntry.date
      state.OTPayRate = overtimeEntry.OTPayRate
      state.OTBillRate = overtimeEntry.OTBillRate
      state.hours = overtimeEntry.hours
    },
    clearOvertimeEntry (state) {
      state.id = null
      state.assignmentId = null
      state.date = null
      state.OTPayRate = null
      state.OTBillRate = null
      state.hours = null
    }
  },
  actions: {
    getOvertimeEntries: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting overtime entries, please wait...' })

      return api.doGet({ path: PATH_OVERTIME_ENTRIES, parameters: filters })
        .then(json => json.data)
        .then(overtimeEntries => {
          commit('updateStatus', { status: COMPLETE })
          commit('setOvertimeEntries', overtimeEntries)
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to select overtime entries')
        })
    },
    getOvertimeEntry ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting overtime entry, please wait...' })
      return api.doGet({ path: PATH_OVERTIME_ENTRIES, parameters: Object.assign({}, { id: id }) })
        .then(json => json.data)
        .then(overtimeEntry => {
          commit('updateStatus', { status: COMPLETE })
          commit('setOvertimeEntry', overtimeEntry)
          hideProgressModal({ dispatch })
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to select overtime entry')
        })
    },
    saveOvertimeEntries: ({ commit, dispatch }, overtimeEntries) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving overtime entries, please wait...' })

      return api.doPost({ path: PATH_OVERTIME_ENTRIES, data: overtimeEntries })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save overtime entries.')
          }

          commit('clearOvertimeEntry')
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Overtime entries saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to save overtime entries')

          throw error
        })
    },
    updateOvertimeEntry: ({ commit, dispatch }, overtimeEntry) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Updating overtime entry, please wait...' })

      return api.doPut({ path: PATH_OVERTIME_ENTRIES, data: overtimeEntry })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to update overtime entry')
          }

          commit('clearOvertimeEntry')
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Overtime entry updated')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to update overtime entry')

          throw error
        })
    },
    deleteOvertimeEntry: ({ commit, dispatch }, overtimeEntryId) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting overtime entry, please wait...' })

      return api.doDelete({ path: PATH_OVERTIME_ENTRIES, parameters: Object.assign({}, { id: overtimeEntryId }) })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to delete overtime entry')
          }

          commit('clearOvertimeEntry')
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Overtime entry deleted')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to delete overtime entry')

          throw error
        })
    }
  }
}

export default overtimeEntries
